import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BasePageLayout,
  BaseBox,
  BaseTypography,
} from "../../Common/UI/exports";

function Utils() {
  const [selectedProcess, setSelectedProcess] = useState("");
  const [selectedFlow, setSelectedFlow] = useState("");
  const navigate = useNavigate();
  const email = localStorage.getItem("email");

  const handleNext = (processId, flow) => {
    if (processId === "encryption-decryption") {
      navigate("/util/crypto", { state: { email } });
    } else if (processId === "key-generator") {
      navigate("/util/keys", { state: { email } });
    } else if (processId === "git") {
      navigate("/util/git", { state: { email } });
    }
  };

  const processes = [
    {
      id: "encryption-decryption",
      title: "Encryption / Decryption",
      desc: "Encrypt/Decrypt data",
      icon: "🗝️",
      hasFlow: false,
    },
    {
      id: "key-generator",
      title: "Crypto Keys Generator",
      desc: "Generate Crypto Keys",
      icon: "⚡",
      hasFlow: false,
    },
    {
      id: "git",
      title: "Git",
      desc: "Git utilities",
      icon: "⚡",
      hasFlow: false,
    },
  ].filter(Boolean);

  const handleCardClick = (proc) => {
    setSelectedProcess(proc.id);
    setSelectedFlow("");

    if (!proc.hasFlow) {
      handleNext(proc.id);
    }
  };

  return (
    <BasePageLayout sidebarItems={[]}>
      <BaseBox
        sx={{
          textAlign: "center",
          margin: "0",
          maxWidth: "900px",
          padding: 2,
        }}
      >
        {/* Process Cards */}
        <BaseBox
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: 3,
            justifyContent: "center",
          }}
        >
          {processes.map((proc) => (
            <BaseBox
              key={proc.id}
              onClick={() => handleCardClick(proc)}
              sx={{
                p: 3,
                borderRadius: "16px",
                backgroundColor:
                  selectedProcess === proc.id ? "#e0f7fa" : "background.paper",
                boxShadow:
                  selectedProcess === proc.id
                    ? "0 6px 14px rgba(0,0,0,0.25)"
                    : "0 3px 8px rgba(0,0,0,0.12)",
                cursor: "pointer",
                transition: "all 0.3s ease",
                textAlign: "center",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
                },
              }}
            >
              <BaseTypography sx={{ fontSize: "2rem" }}>
                {proc.icon}
              </BaseTypography>
              <BaseTypography sx={{ fontWeight: 600, mt: 1 }}>
                {proc.title}
              </BaseTypography>
              <BaseTypography
                sx={{
                  color: "text.secondary",
                  fontSize: "0.9rem",
                  mt: 0.5,
                }}
              >
                {proc.desc}
              </BaseTypography>
            </BaseBox>
          ))}
        </BaseBox>
      </BaseBox>
    </BasePageLayout>
  );
}

export default Utils;
